import { LoginOutlined, UserOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import { programLabels } from '@/config';
import { getManufacturerByProgram } from '@/libs/util';
import useGlobalConfig from '@/store/global';

import AlphanineIntroduction from './alphanine';
import Common from './common';
import GamunexIntroduction from './gamunex';
import ProlastinIntroduction from './prolastin';
import XembifyIntroduction from './xembify';

const octapharmaTitle = {
  cutaquig: 'SUPPORT FOR PATIENTS AND PROVIDERS',
  fibryga: 'SUPPORT FOR PATIENTS AND PROVIDERS',
  nuwiq: 'COPAY AND REIMBURSEMENT ASSISTANCE FOR PATIENTS AND PROVIDERS',
  octagam: 'SUPPORT FOR PATIENTS AND PROVIDERS',
  panzyga: 'SUPPORT FOR PATIENTS AND PROVIDERS',
  wilate: 'COPAY AND REIMBURSEMENT ASSISTANCE FOR PATIENTS AND PROVIDERS',
};

const nonProviderSupport = ['xembify', 'prolastin', 'alphanine', 'gamunex'];

const ProgramIntroduction = () => {
  const { program, themeColor } = useGlobalConfig();
  const name = program.name;
  const isOctaPharma = getManufacturerByProgram(name)?.indexOf('Octapharma') !== -1;

  const ProgramTitle = () => {
    if (name === 'alphanine') {
      return <AlphanineIntroduction themeColor={themeColor} />;
    }
    if (name === 'gamunex') {
      return <GamunexIntroduction themeColor={themeColor} />;
    }
    if (name === 'prolastin') {
      return <ProlastinIntroduction themeColor={themeColor} />;
    }
    if (name === 'xembify') {
      return <XembifyIntroduction themeColor={themeColor} />;
    }
    if (isOctaPharma) {
      return (
        <div className="text-xl md:text-3xl font-bold">
          {octapharmaTitle[name as keyof typeof octapharmaTitle]}
        </div>
      );
    }

    return <Common color={themeColor} name={name && name.toUpperCase()} />;
  };

  return (
    <div className="text-base">
      <ProgramTitle />

      {nonProviderSupport.includes(name) ? (
        <div className="my-10 grid grid-cols-1 md:grid-cols-2 space-y-4 md:space-y-0 md:space-x-6">
          <Button
            type="primary"
            icon={<UserOutlined />}
            size="large"
            style={{ backgroundColor: themeColor, borderColor: themeColor }}
            onClick={() => (window.location.href = '/signup')}
          >
            Provider Registration
          </Button>
          <Button
            type="primary"
            icon={<LoginOutlined />}
            size="large"
            style={{ backgroundColor: themeColor, borderColor: themeColor }}
            onClick={() => (window.location.href = '/signin')}
          >
            Provider Login
          </Button>
        </div>
      ) : (
        <div className="grid gap-x-10 md:grid-cols-2">
          <div className="mt-10">
            <h1 className="text-2xl font-bold">HEALTHCARE PROVIDERS</h1>
            <div className="mt-2">
              If you are a pharmacy, prescriber&apos;s office, or biller please click the button
              below.
            </div>
            <div className="mt-8">
              <Button
                type="primary"
                size="large"
                block
                style={{ backgroundColor: themeColor }}
                onClick={() => (window.location.href = '/provider_support')}
              >
                I am a healthcare provider
              </Button>
            </div>
          </div>

          <div className="mt-10">
            <h1 className="text-2xl font-bold">PATIENTS</h1>
            <div className="mt-2">If you are a patient please click the button below.</div>
            <div className="mt-8">
              <Button
                type="primary"
                size="large"
                block
                style={{ backgroundColor: themeColor }}
                onClick={() => (window.location.href = '/patient_support')}
              >
                I am a patient
              </Button>
            </div>
          </div>
        </div>
      )}

      <div className="mt-10">
        This program is subject to change or discontinuation by&nbsp;
        <b>{getManufacturerByProgram(name)}</b>
        &nbsp;at any time, for any reason, and with or without prior notice. This portal is
        administered by&nbsp;
        <a target="_blank" href="https://medmonk.com/" className="text-sky-700 hover:underline">
          Medmonk
        </a>
        &nbsp;for the {programLabels[name]?.label} Program.
      </div>
    </div>
  );
};

export default ProgramIntroduction;
